export default __webpack_public_path__ + "static/media/ip.5bd63a70.md";